import { render, staticRenderFns } from "./JuniorHandlingScores.vue?vue&type=template&id=caca53dc"
import script from "./JuniorHandlingScores.vue?vue&type=script&lang=ts"
export * from "./JuniorHandlingScores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports